// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"e6f64211","622":"8cbb9a91"}[chunkId] + ".chunk.css";
};